import { z } from 'zod';
import {
  EgressStrategySchema,
  TailscaleRoutingSnapshotSchema,
  ProxyContextJwtTypeSchema,
  ToolExecutionSourceSchema,
} from './proxy-context.dto';

export const ToolProxyRequestSchema = z.object({
  threadId: z.string(),
  toolCallId: z.string(),
  executionId: z.string().optional(),
  sessionId: z.string(),

  applicationId: z.string(),
  applicationUrl: z.string().optional(),
  tenantId: z.string(),
  tailscaleNetworkId: z.string().optional(),
  tailscaleRouting: TailscaleRoutingSnapshotSchema.optional(),
  twingateNetworkId: z.string().optional(),
  isInternalApp: z.boolean(),
  egressStrategy: EgressStrategySchema,
  credentialId: z.string().optional(),
  proxyCredentialId: z.string().optional(),
  userId: z.string().optional(),
  jwtType: ProxyContextJwtTypeSchema.optional(),
  source: ToolExecutionSourceSchema,
  executingCloudService: z.string().min(1).optional(),

  method: z.string(),
  url: z.string(),
  headers: z.record(z.string(), z.string()),
  body: z.string().optional(),
  bodyEncoding: z.enum(['utf8', 'base64']).optional(),

  toolType: z.enum(['HTTP', 'PYTHON']),
  toolName: z.string(),

  parentToolCallId: z.string().optional(),
  maxRedirects: z.number().optional(),
  persistCookieJar: z.boolean().optional(),
  requestsPerMinute: z.number().int().positive().optional(),
});

export type ToolProxyRequestDto = z.infer<typeof ToolProxyRequestSchema>;
